import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import { useNavigate, Link,useLocation  } from "react-router-dom";
import Logo from '../images/logo_transparent.png';
import { Form, Input, Button, Typography } from 'antd';
import { FaUserPlus, FaGoogle } from 'react-icons/fa';
import '../styles/signuppage.css'; // new stylesheet
import { GoogleLogin } from "@react-oauth/google";
import { AUTH_PROVIDER, GOOGLE_CLIENT_ID, createGooglePassword, getGoogleProfile } from '../utils/googleAuth';

const SIGNUP_URL = 'https://epolylearning.com/Services/polyquiz.svc/SubmitUserData';
const LOGIN_URL = 'https://epolylearning.com/Services/polyquiz.svc/GetUserData';

const SignupPage = () => {
  const [signuperror, setSignUpError] = useState(false);
  const [signuperrorGoogleAct, setSignuperrorGoogleAct] = useState(false);
  const [signupmessage, setSignUpMessage] = useState(false);
  const [googleSignupError, setGoogleSignupError] = useState(false);
  const [googleEmailAccountMsg, setGoogleEmailAccountMsg] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false); // NEW
  const [isGoogleProcessing, setIsGoogleProcessing] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const itemStr = localStorage.getItem('isLogin');
  const item = itemStr ? JSON.parse(itemStr) : null;
  const now = new Date();

  const { Title } = Typography;

  // AntD form instance
  const [form] = Form.useForm();

  function setUser(key, email, username, firstname, ttl, authProvider) {
    const nowLocal = new Date();
    const itemLocal = {
      userid: key,
      email: email,
      username: username,
      firstname: firstname,
      authProvider: authProvider,
      expiry: nowLocal.getTime() + ttl,
    };
    localStorage.setItem('isLogin', JSON.stringify(itemLocal));

    const redirectTo = location?.state?.redirectAfterLogin || '/';
    navigate(redirectTo);

    setTimeout(() => {
      try {
        window.location.reload();
      } catch (e) {
        // fallback: nothing
      }
    }, 120);
  }

  const submitSignup = async (payload) => {
     console.log("SUBMIT SIGNUP CALLED");
    const json = JSON.stringify(payload);
    const headers = { 'Content-Type': 'application/json' };

    const response = await axios.post(SIGNUP_URL, json, { headers });
    console.log(response.data);
    return response.data;
    
  };

  const loginUser = async (payload) => {
    const json = JSON.stringify(payload);
    const headers = { 'Content-Type': 'application/json' };

    const response = await axios.post(LOGIN_URL, json, { headers });
    return response.data?.GetUserDataResult?.LoginList?.[0];
  };

  const handleSignupResponse = (userData) => {
    if (
      
      userData.SubmitUserDataResult.Firstname === "Email id already exist" &&
      userData.SubmitUserDataResult.Lastname === "Signup Failed"
      
    ) {
      console.log(userData)
      setSignUpError(true);
      return;
    }

    if (
      
      userData.SubmitUserDataResult.Firstname === "Email id already exist" &&
      userData.SubmitUserDataResult.Lastname === "Registered using Google account"
      
    ) {
      console.log(userData)
      setSignuperrorGoogleAct(true);
      return;
    }

    if (
      userData.SubmitUserDataResult.Firstname === "User Registered Successfully" &&
      userData.SubmitUserDataResult.Lastname === "Signup Successful"
    ) {
      console.log(userData)
      setSignUpMessage(true);
      form.resetFields();
    }
  };
  async function onFinish(data) {
    console.log("ONFINISH FIRED");
    setSignUpError(false);
    setSignuperrorGoogleAct(false);
    setSignUpMessage(false);
    setGoogleSignupError(false);
    setGoogleEmailAccountMsg(false);
    setIsProcessing(true); // NEW: start processing state
    try {
      const userData = await submitSignup({
        fname: data.firstname,
        lname: data.lastname,
        uname: data.username,
        email: data.email,
        pass: data.password,
        authProvider: AUTH_PROVIDER.EMAIL,
        signupType: AUTH_PROVIDER.EMAIL,
        registrationType: AUTH_PROVIDER.EMAIL,
        isGoogleSignup: false,
        requiresActivation: true,
      });

      handleSignupResponse(userData);
    } catch (error) {
      // keep original behaviour (log)
      console.error(error);
    } finally {
      setIsProcessing(false); // NEW: always stop processing
    }
  }

  async function handleGoogleSignup(credentialResponse) {
    setSignUpError(false);
    setSignuperrorGoogleAct(false);
    setSignUpMessage(false);
    setGoogleSignupError(false);
    setGoogleEmailAccountMsg(false);
    setIsGoogleProcessing(true);

    try {
      const profile = getGoogleProfile(credentialResponse);

      if (!profile?.email) {
        setGoogleSignupError(true);
        return;
      }

      const googlePassword = createGooglePassword(profile.email, profile.googleId);
      const googleAuthPayload = {
        email: profile.email,
        pass: googlePassword,
        authProvider: AUTH_PROVIDER.GOOGLE,
        loginType: AUTH_PROVIDER.GOOGLE,
        signupType: AUTH_PROVIDER.GOOGLE,
        isGoogleSignup: true,
        googleId: profile.googleId,
        googleCredential: profile.credential,
      };

      const existingGoogleUser = await loginUser(googleAuthPayload);
      if (existingGoogleUser?.IsActivated === true) {
        setUser(
          existingGoogleUser.UserId,
          existingGoogleUser.Email,
          existingGoogleUser.UserName,
          existingGoogleUser.FirstName,
          2592000000000,
          AUTH_PROVIDER.GOOGLE
        );
        return;
      }

      const userData = await submitSignup({
        fname: profile.firstname,
        lname: profile.lastname,
        uname: profile.username,
        email: profile.email,
        pass: googlePassword,
        authProvider: AUTH_PROVIDER.GOOGLE,
        signupType: AUTH_PROVIDER.GOOGLE,
        registrationType: AUTH_PROVIDER.GOOGLE,
        isGoogleSignup: true,
        requiresActivation: false,
        googleId: profile.googleId,
        googleCredential: profile.credential,
      });

      if (
        userData.SubmitUserDataResult.Firstname === "Email id already exist" &&
        userData.SubmitUserDataResult.Lastname === "Signup Failed"
      ) {
        setGoogleEmailAccountMsg(true);
        return;
      }

      if (
        userData.SubmitUserDataResult.Firstname === "User Registered Successfully" &&
        userData.SubmitUserDataResult.Lastname === "Signup Successful"
      ) {
        const newGoogleUser = await loginUser(googleAuthPayload);
        if (newGoogleUser?.IsActivated === true) {
          setUser(
            newGoogleUser.UserId,
            newGoogleUser.Email,
            newGoogleUser.UserName,
            newGoogleUser.FirstName,
            2592000000000,
            AUTH_PROVIDER.GOOGLE
          );
          return;
        }
      }

      setGoogleSignupError(true);
    } catch (error) {
      console.error(error);
      setGoogleSignupError(true);
    } finally {
      setIsGoogleProcessing(false);
    }
  }

  useEffect(() => {
    try {
      if (item && item.expiry && item.expiry > now.getTime()) {
        navigate('/');
      }
    } catch (e) {
      // ignore parsing issues, keep user on signup
    }
  }, []);

  return (
    <>
      <MetaTags>
        <title>Register for a new Account - PolyQuiz</title>
        <meta id="meta-description" name="description" />
      </MetaTags>

      {/* Branding / SEO-friendly intro (placed above the signup card) */}
      <header className="signup-branding" aria-label="About PolyQuizz">
        <div className="signup-branding-inner">
          <h2 className="brand-title">PolyQuizz — Smart Practice for Exams & Certifications</h2>
          <p className="brand-lead">
            PolyQuizz helps students and professionals prepare effectively for competitive exams,
            certifications, and classroom tests. We combine realistic multiple-choice practice, timed mock tests,
            and performance analytics to help you improve faster and track progress.
          </p>

          <ul className="brand-benefits" aria-hidden="false">
            <li><strong>Targeted practice:</strong> Topic-wise practice tests to strengthen weak areas.</li>
            <li><strong>Exam-style mocks:</strong> Simulated tests that mirror real exam conditions.</li>
            <li><strong>Instant feedback:</strong> Detailed explanations and analytics for every question.</li>
            <li><strong>Flexible learning:</strong> Practice on web or mobile — anytime, anywhere.</li>
          </ul>

          <p className="brand-cta">
            Create your free account below to start personalized practice and get better results on exam day.
          </p>
        </div>
<div className="free-trial-badge">
  <span className="gift-icon">🎁</span>
  Get <strong>2 free practice tests</strong> instantly when you sign up!
</div>

      </header>

      <div className="signup-page-root">
        <div className="signup-card">
          <div className="signup-header">
           {/* <img className="signup-logo" src={Logo} alt="logo" /> */}
            <div className="signup-title-wrap">
              <h1 className="signup-title">Create an Account</h1>
              <div className="signup-subtitle">Join PolyQuizz and start your practice today</div>
            </div>
          </div>

          <div className="signup-form-wrap">
            {/* <Title level={4} className="antd-hidden-heading">SIGN UP</Title> */}

            <Form
              form={form}
              name="register"
              onFinish={onFinish}
              layout="vertical"
              scrollToFirstError
            >
              <Form.Item
                name="firstname"
                label="First Name"
                rules={[
                  { required: true, message: 'Please input your First Name!' },
                  { max: 32, message: 'Maximum of 32 characters allowed.' },
                  { whitespace: true }
                ]}
              >
                <Input placeholder="John Doe" />
              </Form.Item>

              <Form.Item
                name="lastname"
                label="Last Name"
                rules={[
                  { required: false },
                  { max: 32, message: 'Maximum of 32 characters allowed.' },
                  { whitespace: true }
                ]}
              >
                <Input placeholder="Optional" />
              </Form.Item>

             {/*  <Form.Item
                name="username"
                label="User Name"
                rules={[
                  { required: true, message: 'Please choose a username!' },
                  { max: 16, message: 'Maximum of 16 characters allowed.' },
                  { whitespace: false }
                ]}
              >
                <Input placeholder="username" />
              </Form.Item> */}

              <Form.Item
                name="email"
                label="Email"
                tooltip="E-Mail verification required."
                rules={[
                  { type: 'email', message: 'The input is not valid E-mail!' },
                  { required: true, message: 'Please input your E-mail!' }
                ]}
              >
                <Input placeholder="your.email@example.com" />
              </Form.Item>

              <Form.Item
                name="password"
                label="Password"
                tooltip="Minimum of 8 characters."
                rules={[
                  { required: true, message: 'Please input your password!' },
                  { min: 8, message: 'Minimum password length is 8 characters.' },
                  { max: 16, message: 'Maximum password length is 16 characters.' }
                ]}
                hasFeedback
              >
                <Input.Password placeholder="••••••••" />
              </Form.Item>

              <Form.Item
                name="confirm"
                label="Confirm Password"
                dependencies={['password']}
                hasFeedback
                rules={[
                  { required: true, message: 'Please confirm your password!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('The two passwords that you entered do not match!'));
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="••••••••" />
              </Form.Item>

             <Form.Item className="signup-submit">
  <Button
    type="primary"
    htmlType="submit"
    className="signup-btn"
    disabled={isProcessing}
  >
    {isProcessing ? (
      <>
        <span className="btn-spinner" aria-hidden="true"></span>
        Processing…
      </>
    ) : (
      <>
        <FaUserPlus style={{ marginRight: 8 }} />
        Sign Up
      </>
    )}
  </Button>

  <p className="signup-agreement">
    By signing up, you agree to our{" "}
    <Link to="/terms-of-service" className="link-text">
      Terms of Service
    </Link>{" "}
    and{" "}
    <Link to="/privacy-policy" className="link-text">
      Privacy Policy
    </Link>.
  </p>
</Form.Item>
</Form>
            <div className="signup-divider" role="separator" aria-label="or">
              <span>or</span>
            </div>

            <div className="google-signup-section">
              <div className="google-signup-label">
                <FaGoogle aria-hidden="true" />
                <span>Continue with Google</span>
              </div>
              {GOOGLE_CLIENT_ID ? (
                <GoogleLogin
                  onSuccess={handleGoogleSignup}
                  onError={() => setGoogleSignupError(true)}
                  text="signup_with"
                  shape="rectangular"
                  size="large"
                  width="100%"
                />
              ) : (
                <div className="signup-message info">
                  Google sign up is not configured for this environment.
                </div>
              )}
              {isGoogleProcessing && (
                <div className="signup-message info">
                  Creating your account with Google...
                </div>
              )}
            </div>









            {signuperror && (
              <div className="signup-message error">
                This Email Id is already registered.
              </div>
            )}

             {signuperrorGoogleAct && (
              <div className="signup-message error">
                You have already signed up using Google Account associated with this email. Please log in with your Google Account.
              </div>
            )}

            {signupmessage && (
              <div className="signup-message success">
                Registration Successful. Please check your Email for the Activation Link to activate your account.
              </div>
            )}

            {googleEmailAccountMsg && (
              <div className="signup-message error">
                This email is already registered with email/password. Please log in with your email and password.
              </div>
            )}

            {googleSignupError && (
              <div className="signup-message error">
                Google sign up could not be completed. Please try again.
              </div>
            )}
            <div className="signup-footer-text">
             Already have an account?{" "}
   <Link
     to="/login"
     state={{ redirectAfterLogin: location?.state?.redirectAfterLogin || '/' }}
     className="signin-link"
   >
     Log In
   </Link>
            </div>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default SignupPage;
